import { Box } from "@mui/material";
import React from "react";
import classess from "./Style.module.css";
import Footer from "./Footer";

const Personalpronomen = () => {
  const Title = "";
  const SubTitle1 = ["شخص", "Nominativ", "Akkusativ", "Dativ", "Genitiv"];
  const SubTitle2 = ["", "(فاعل)", "(م.مستقیم)", "(م.غ.مستقیم)", "(ملکی)"];
  const ST1 = ["ICH", "ich", "mich", "mir", "meiner"];
  const ST2 = ["DU", "du", "dich", "dir", "deiner"];
  const ST3 = ["ER", "er", "ihn", "ihm", "seiner"];
  const ST4 = ["SIE", "sie", "sie", "ihr", "ihrer"];
  const ST5 = ["ES", "es", "es", "ihm", "seiner"];
  const ST6 = ["WIR", "wir", "uns", "uns", "unser"];
  const ST7 = ["IHR", "ihr", "euch", "euch", "euer"];
  const ST8 = ["sie-Sie", "sie-Sie", "sie-Sie", "ihnen-Ihnen", "ihrer-Ihrer"];
  const FOOTER1 = {
    Title:
      "۱. حالت Nominativ (فاعل) Nominativ : زمانی استفاده می‌شود که ضمیر فاعل جمله باشد، یعنی انجام‌دهنده‌ی عمل.",
    Type: "Nominativ",
    Examples: {
      1: ["Ich gehe in die Schule.", "من به مدرسه می‌روم"],
      2: ["Du bist mein Freund.", "تو دوست من هستی"],
      3: ["Er liest ein Buch.", "او (مذکر) یک کتاب می‌خواند"],
    },
  };
  const FOOTER2 = {
    Title:
      "۲. حالت Akkusativ (مفعول مستقیم) : Akkusativ برای مفعول مستقیم به کار می‌رود، یعنی چیزی که مستقیماً تحت تأثیر فعل قرار می‌گیرد.",
    Type: "Akkusativ",
    Examples: {
      1: ["Sie liebt mich.", "او (مونث) مرا دوست دارد"],
      2: ["Ich sehe dich.", "من تو را می‌بینم"],
      3: ["Er ruft uns an.", "او (مذکر) به ما زنگ می‌زند"],
    },
  };
  const FOOTER3 = {
    Title: "✅مثال با für (که باعث می‌شود 'du' به 'dich' تغییر کند):",
    Type: "Akkusativ",
    Examples: {
      1: ["Das Geschenk ist für dich.", "این هدیه برای تو است"],
    },
  };
  const FOOTER4 = {
    Title:
      "۳. حالت Dativ (مفعول غیرمستقیم) : Dativ زمانی استفاده می‌شود که ضمیر مفعول غیرمستقیم باشد، یعنی گیرنده‌ی عمل.",
    Type: "Dativ",
    Examples: {
      1: ["Ich gebe dir ein Buch.", "من به تو یک کتاب می‌دهم"],
      2: ["Kannst du mir helfen?", "می‌توانی به من کمک کنی؟"],
      3: ["Er hat uns eine E-Mail geschickt.", "او برای ما یک ایمیل فرستاد"],
    },
  };
  const FOOTER5 = {
    Title: "✅ مثال با mit (که باعث می‌شود 'du' به 'dir' تغییر کند):",
    Type: "Akkusativ",
    Examples: {
      1: ["Ich fahre mit dir nach Berlin", "من با تو به برلین می‌روم"],
    },
  };
  const FOOTER6 = {
    Title:
      "۴. حالت Genitiv (ملکی) : Genitiv برای مالکیت استفاده می‌شود و در مکالمه کمتر رایج است.",
    Type: "Genitiv",
    Examples: {
      1: ["Das ist das Auto meiner Mutter.", "این ماشین مادر من است"],
      2: ["Ich gedenke deiner.", "من به یاد تو هستم"],
    },
  };

  return (
    <Box className={classess.Wrapper}>
      <span>{Title}</span>
      <Box className={classess.WP}>
        {SubTitle1.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle1.length - 3}px`,
                backgroundColor: "rgba(150, 150, 150, 0.2)",
                fontSize: "1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {SubTitle2.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB2}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                backgroundColor: "rgba(190, 190, 190, 0.1)",
                fontSize: "0.8rem",
                lineHeight: "13px",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST1.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                fontSize: "1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST2.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                fontSize: "1rem",
              }}
            >
              {opt}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST3.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                fontSize: "1rem",
              }}
            >
              {index === 1 ? (
                <span className={classess.tooltip} data-title="iim">
                  {opt}
                </span>
              ) : index === 2 ? (
                <span className={classess.tooltip} data-title="iin">
                  {opt}
                </span>
              ) : index === 4 ? (
                <span className={classess.tooltip1} data-title="او مذکر">
                  {opt}
                </span>
              ) : (
                opt
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST4.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                fontSize: "1rem",
              }}
            >
              {index === 0 ? (
                <span className={classess.tooltip0} data-title="iigha">
                  {opt}
                </span>
              ) : index === 1 ? (
                <span className={classess.tooltip} data-title="iiYa">
                  {opt}
                </span>
              ) : index === 4 ? (
                <span className={classess.tooltip1} data-title="او مونث">
                  {opt}
                </span>
              ) : (
                opt
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST5.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                fontSize: "1rem",
              }}
            >
              {index === 1 ? (
                <span className={classess.tooltip0} data-title="iim">
                  {opt}
                </span>
              ) : index === 4 ? (
                <span className={classess.tooltip1} data-title="آن - او خنثی">
                  {opt}
                </span>
              ) : (
                opt
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST6.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                fontSize: "1rem",
              }}
            >
              {index === 0 ? (
                <span className={classess.tooltip0} data-title="onZa">
                  {opt}
                </span>
              ) : index === 1 || index === 2 ? (
                <span className={classess.tooltip} data-title="ons">
                  {opt}
                </span>
              ) : (
                opt
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST7.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                fontSize: "1rem",
              }}
            >
              {index === 0 ? (
                <span className={classess.tooltip0} data-title="aYa">
                  {opt}
                </span>
              ) : index === 1 || index === 2 ? (
                <span className={classess.tooltip} data-title="aish">
                  {opt}
                </span>
              ) : index === 4 ? (
                <span
                  className={classess.tooltip1}
                  data-title="شما (جمع غیررسمی)"
                >
                  {opt}
                </span>
              ) : (
                opt
              )}
            </Box>
          ))}
      </Box>
      <Box className={classess.WP}>
        {ST8.slice()
          .reverse()
          .map((opt, index) => (
            <Box
              key={index}
              className={classess.WB}
              sx={{
                width: `${330 / SubTitle2.length - 3}px`,
                fontSize: "1rem",
              }}
            >
              {index === 0 ? (
                <span
                  className={classess.tooltip0}
                  data-title="igha-Igha"
                  style={{ fontSize: "0.9rem" }}
                >
                  {opt}
                </span>
              ) : index === 1 ? (
                <span
                  className={classess.tooltip}
                  data-title="inen-Inen"
                  style={{ fontSize: "0.85rem" }}
                >
                  {opt}
                </span>
              ) : index === 4 ? (
                <span
                  className={classess.tooltip1}
                  data-title="آن‌ها / شما (رسمی)"
                >
                  {opt}
                </span>
              ) : (
                opt
              )}
            </Box>
          ))}
      </Box>
      <Footer FOOTER={FOOTER1} />
      <Footer FOOTER={FOOTER2} />
      <Box className={classess.Possessivartikel1}>
        ⏳ حروف اضافه‌ای که همیشه Akkusativ می‌گیرند: durch, für, gegen, ohne,
        um, bis
      </Box>
      <Footer FOOTER={FOOTER3} />
      <Footer FOOTER={FOOTER4} />
      <Box className={classess.Possessivartikel1}>
        ⏳ حروف اضافه‌ای که همیشه Dativ می‌گیرند: aus, bei, mit, nach, seit,
        von, zu, gegenüber
      </Box>
      <Footer FOOTER={FOOTER5} />
      <Footer FOOTER={FOOTER6} />
    </Box>
  );
};

export default Personalpronomen;
